import { render, staticRenderFns } from "./active-cards.vue?vue&type=template&id=8bc4f2ec&"
import script from "./active-cards.vue?vue&type=script&lang=js&"
export * from "./active-cards.vue?vue&type=script&lang=js&"
import style0 from "./active-cards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports